import { getCall } from "../../../../../axios/api";
import {
  transactionsReportChartUrl,
  transactionsReportExportUrl,
  transactionsReportUrl
} from "../../../../../axios/services/apiList";

export function transactionsReportList({ queryParams }) {
  return getCall(transactionsReportUrl({ queryParams }));
}

export function transactionsReportListExport({ queryParams }) {
  return getCall(transactionsReportExportUrl({ queryParams }));
}

export function transactionsChartDetails({ queryParamsChart }) {
  return getCall(transactionsReportChartUrl({ queryParamsChart }));
}
